import { useAppDispatch, useAppSelector } from 'hooks/useStore'
import { ReactElement, useState } from 'react'
import styled from 'styled-components'
import { dashboardActions } from '../../store/store.dashboard'
import { DatePicker } from '@mui/x-date-pickers'
import { componentByMonth } from './dashboardFigures.helpers'
import DashboardInterventionsFigures from './DashboardFigures.interventions'
import DashboardQuotationsFigures from './DashboardFigures.quotations'
import DashboardInvoicesFigures from './DashboardFigures.invoices'
import { MenuItem, Select } from '@mui/material'
import DashboardOthersFigures from './DashboardFigures.others'

export default function DashboardFigures(): ReactElement {
  const dispatch = useAppDispatch()
  const { dateStart, dateEnd } = useAppSelector((state) => state.dashboard)
  const [display, setDisplay] = useState<'interventions' | 'devis' | 'factures' | 'utilisateurs'>()

  return (
    <Wrapper>
      <Select value={display} onChange={(e) => setDisplay(e.target.value as typeof display)}>
        <MenuItem value="interventions">Interventions</MenuItem>
        <MenuItem value="devis">Devis</MenuItem>
        <MenuItem value="factures">Factures</MenuItem>
        <MenuItem value='utilisateurs'>Utilisateurs</MenuItem>
      </Select>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 50, marginTop: 50 }}>
        <DatePicker
          label="Mois"
          views={[ 'month', 'year']}
          value={dateStart}
          onChange={(value) => {
            if (!value) return

            dispatch(dashboardActions.setDateStart(value.startOf('month')))
            dispatch(dashboardActions.setDateEnd(value.endOf('month')))
          }}
          timezone="Europe/Paris"
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 50 }}>
        <table style={{ border: 'solid 1px', margin: 20 }}>
          <tr>
            <th></th>
            {componentByMonth({
              dateStart,
              dateEnd,
              component: (year, month) => <th style={{ padding: 10, textAlign: 'center' }}>{year + '/' + month}</th>,
            })}
          </tr>

          {display === 'interventions' && <DashboardInterventionsFigures />}
          {display === 'devis' && <DashboardQuotationsFigures />}
          {display === 'factures' && <DashboardInvoicesFigures />}
          {display === 'utilisateurs' && <DashboardOthersFigures />}
        </table>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`
